//
//
//
//
//
//
//
//
//

import urlParam from 'url-param-object';

const from = urlParam.getParamValue('openFrom');
const isAndroid = urlParam.getParamValue('system') === 'android';
const statusBarHeight = urlParam.getParamValue('statusBarHeight') || 0;
const height = urlParam.getParamValue('height') || 0;
const SH = height - statusBarHeight;

export default {
  name: 'app',
  data() {
    return {
      isAndroid: isAndroid && from === 'app',
      screenHeight: `${SH}px`,
    };
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/App.vue